export default{
    methods:{
        getUrlParams(){
    if (localStorage.getItem('utm_source')) {
        localStorage.removeItem('utm_source')
    }

    if (localStorage.getItem('utm_campaign')) {
        localStorage.removeItem('utm_campaign')
    }

    if (localStorage.getItem('utm_medium')) {
        localStorage.removeItem('utm_medium')
    }

    let referrer = document.referrer

			if (referrer) {
				let utmSource = ''
				let utmCampaign = ''

				if (referrer.includes('google.com') || referrer.includes('google.ru')) {
					utmSource = 'google'
					utmCampaign = 'organic'
				} else if (referrer.includes('yandex.ru')) {
					utmSource = 'yandex'
					utmCampaign = 'organic'
				} else if (referrer.includes('ya.ru')) {
					utmSource = 'yandex'
					utmCampaign = 'organic'
				} else if (
					referrer.includes('mail.ru') ||
					referrer.includes('go.mail.ru')
				) {
					utmSource = 'mail'
					utmCampaign = 'organic'
				}

				if (utmSource) {
					localStorage.setItem('utm_source', utmSource)
					localStorage.setItem('utm_campaign', utmCampaign)
				}
			}
            
            if(this.$route.query){
                for (let param in this.$route.query) {
                    if(
                        param === 'utm_source'
                        || param === 'utm_medium'
                        || param === 'utm_term'
                        || param === 'utm_content'
                        || param === 'utm_campaign'){
                        if(this.$route.query[param]){
                            localStorage.setItem(param, this.$route.query[param])
                        }
                    }
                }
            }
        }
    },
}